<div class="app-screen-shell" [class.app-screen-shell-public]="variant === 'public'" [class.app-screen-shell-guest]="variant === 'guest'" [class.app-screen-layout-public-entry]="layout === 'public-entry'" [class.app-screen-layout-full-height]="layout === 'full-height'" [attr.role]="screenRole">
  @if (showHeader) {
    <header class="app-screen-header" data-testid="screen-header" [class.app-screen-header-public]="isPublicVariant()">
      <button type="button" class="app-screen-header-back" (click)="back.emit()">
        <i [class]="'common.back' | nogoshIcon" aria-hidden="true"></i>
        <span class="sr-only">{{ backLabelKey | translate }}</span>
      </button>
      <div class="app-screen-header-title">
        @if (isPublicVariant() && brandLabel) {
          <a class="app-screen-header-brand" [href]="brandHref">{{ brandLabel }}</a>
        }
        @if (titleActionable) {
          <button type="button" class="app-screen-header-title-button" (click)="titleAction.emit()" [attr.aria-label]="titleActionLabelKey ? (titleActionLabelKey | translate) : null">
            {{ titleKey ? (titleKey | translate) : resolvedTitle() }}
          </button>
        } @else {
          <h1>{{ titleKey ? (titleKey | translate) : resolvedTitle() }}</h1>
        }
        @if (subtitle) {
          <small>{{ subtitle }}</small>
        }
      </div>
      <div #headerActions class="app-screen-header-actions">
        <ng-content select="[screen-header-actions]"></ng-content>
      </div>
    </header>
  }

  <div class="app-screen-content" [class.container]="contentWidth === 'standard'" [class.app-screen-content-page]="contentInset === 'page'" [ngClass]="contentClass">
    @if (loading) {
      <app-loading-state [delayMs]="0" [titleKey]="loadingTitleKey" [subtitleKey]="loadingSubtitleKey" [page]="true"></app-loading-state>
    }

    @if (!loading && error) {
      <section class="app-screen-state app-screen-error-state">
        @if (errorIcon) {
          <i [class]="errorIcon" aria-hidden="true"></i>
        }
        <h1>{{ errorTitleKey ? (errorTitleKey | translate) : errorTitle }}</h1>
        @if (errorTextKey || errorText) {
          <p>{{ errorTextKey ? (errorTextKey | translate) : errorText }}</p>
        }
        @if (primaryActionLabelKey || primaryActionLabel) {
          <button type="button" class="btn btn-primary btn-sm px-3" (click)="primaryAction.emit()">
            {{ primaryActionLabelKey ? (primaryActionLabelKey | translate) : primaryActionLabel }}
          </button>
        }
      </section>
    }

    @if (!loading && !error && empty) {
      <section class="app-screen-state app-screen-empty-state">
        @if (emptyIcon) {
          <i [class]="emptyIcon" aria-hidden="true"></i>
        }
        @if (emptyTitleKey || emptyTitle) {
          <h1>{{ emptyTitleKey ? (emptyTitleKey | translate) : emptyTitle }}</h1>
        }
        @if (emptyTextKey || emptyText) {
          <p>{{ emptyTextKey ? (emptyTextKey | translate) : emptyText }}</p>
        }
        @if (primaryActionLabelKey || primaryActionLabel) {
          <button type="button" class="btn btn-primary btn-sm px-3" (click)="primaryAction.emit()">
            {{ primaryActionLabelKey ? (primaryActionLabelKey | translate) : primaryActionLabel }}
          </button>
        }
      </section>
    }

    @if ((!loading || !hideContentWhileLoading) && !error && !empty) {
      <ng-content></ng-content>
    }
  </div>
</div>
